/* eslint-disable camelcase */
import CouponLandingPage from "@/pages/coupon-landing-page/index.vue"
import createComponent from "@/utils/create-component"

let rootElement = document.getElementById("vue-coupon-landing-page")

if (rootElement) {
  const { subscriptionPlan, landingPage } = rootElement.dataset

  const parsedSubscription = JSON.parse(subscriptionPlan)

  const parsedLandingPage = JSON.parse(landingPage)
  const landingPageData = parsedLandingPage.attributes

  let discountPercentage = parsedSubscription.coupon.value

  createComponent({
    name: "CouponLandingPage",
    el: "#vue-coupon-landing-page",
    component: CouponLandingPage,
    props: {
      landingPage: landingPageData,
      plan: parsedSubscription.plan,
      coupon: parsedSubscription.coupon,
      discountPercentage
    }
  })
}
